import { render } from "./AnnualInannualInspectionView.vue?vue&type=template&id=131b17fa"
import script from "./AnnualInannualInspectionView.vue?vue&type=script&lang=js"
export * from "./AnnualInannualInspectionView.vue?vue&type=script&lang=js"

import "./AnnualInannualInspectionView.vue?vue&type=style&index=0&id=131b17fa&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__